export const hasSlateAstOperations = (operations) =>
  operations.some((op) => 'set_selection' !== op.type);
